<template>
  <tr @click="objectClicked($event)"  class="cursor-pointer flex flex-row align-baseline text-center bg-white px-4">
    <td class="w-44 py-1.5 text-sm flex h-fit flex-col text-left">
        <span :class="[props.backgroundColor] + ' ' + [props.textColor]" class="inline-flex items-center  rounded text-xs font-medium ">
          {{ props.name }}
        </span>
      <p class="text-gray-400 text-xs">{{ props.date }}</p>
    </td>
    <td class=" my-auto  text-left  text-sm">
      {{props.problem}}
    </td>
  </tr>
</template>

<script setup>
import { defineProps} from "vue";

let props = defineProps({
  name: String,
  backgroundColor: String,
  textColor: String,
  date: String,
  problem: String,
  url: String
})

function objectClicked(e)
{
  e.preventDefault();
}
</script>

<style scoped>
td{
  word-break: break-word;
}
</style>